import { render, staticRenderFns } from "./order-digital-currency.vue?vue&type=template&id=112bbdc4&scoped=true"
import script from "./order-digital-currency.vue?vue&type=script&lang=js"
export * from "./order-digital-currency.vue?vue&type=script&lang=js"
import style0 from "./order-digital-currency.vue?vue&type=style&index=0&id=112bbdc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "112bbdc4",
  null
  
)

export default component.exports